import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f8ac53e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-content flex-grow-1 d-flex flex-row" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_4 = { "aria-label": "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb m-0" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = {
  key: 0,
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_8 = { class: "survey-edit-controls d-flex flex-row ms-auto" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "info-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "d-flex flex-row mt-5" }, " Survey info ", -1))
const _hoisted_12 = { class: "ps-2 py-3" }
const _hoisted_13 = { class: "form-outline mb-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "description"
}, "Survey description", -1))
const _hoisted_15 = { class: "form-outline mb-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "uploadName"
}, "Date", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "d-flex flex-row mt-4" }, " Files ", -1))
const _hoisted_18 = { class: "ps-2 py-3" }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 0,
  class: "info-content"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "d-flex flex-row mt-5" }, " Project info ", -1))
const _hoisted_22 = { class: "ps-2 py-3" }
const _hoisted_23 = { class: "form-outline mb-4" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "description"
}, "Project name", -1))
const _hoisted_25 = { class: "form-outline mb-4" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "description"
}, "Coordinate system", -1))
const _hoisted_27 = { class: "form-outline mb-4" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "description"
}, "Project location", -1))
const _hoisted_29 = {
  key: 0,
  class: "my-3"
}

import AppHeader from "@/components/Pages/AppHeader.vue";
import SurveyFiles from "@/components/Pages/SurveyFiles.vue";
import Datepicker from "@vuepic/vue-datepicker";
import ProjectPickerSidebar from "@/components/Pages/Edit/ProjectPickerSidebar.vue";
import CoordinateSystemPicker from "@/components/Inputs/CoordinateSystemPicker.vue";
import { useAppStateStore } from "@/store/app-state";
import { onBeforeUnmount, onMounted, watch } from "vue";
import { Utils } from "@/classes/utils/utils";
import { useDataStore } from "@/store/data-store";
import router from "@/router";
import { reactive, ref } from "vue";
import { Survey } from "@/swagger";
import MapLocationPicker from "@/components/Controls/MapLocationPicker.vue";
import { useNotificationStore } from "@/store/notification-store";
import DefaultLayout from "@/views/layouts/DefaultLayout.vue";
import { Constants } from "@/classes/constants";
import StreamSaver from "../external/StreamSaver.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditProjectPage',
  setup(__props) {

const locationPicker = ref();

const notificationStore = useNotificationStore();
const appState = useAppStateStore();
const dataStore = useDataStore();
let intervalId: number | undefined;

const data = reactive({
	isSurveyDirty: false,
	isProjectDirty: false
})

function viewSurvey() {
	router.push({ name: "view", params: { projectId: appState.project.uuid, surveyId: appState.view1Survey.uuid } })
}

function setProjectDirty() {
	data.isProjectDirty = true;
}

function setSurveyDirty() {
	data.isSurveyDirty = true;
}

function startInterval() {
    if (!intervalId) {
        intervalId = setInterval(() => {
            const hasProjectsInProcessing = appState.view1Survey?.inputFiles?.some(file => file.status === "processing" || file.status === "waitingforprocessing");
            if (hasProjectsInProcessing) {
                console.log("Refreshing surveys");
                appState.reloadCurrentProject();
            } else {
                console.log("All projects done processing, stopping interval");
                stopInterval();
            }
        }, 5000);
    }
}

function stopInterval() {
    if (intervalId) {
        clearInterval(intervalId);
        intervalId = undefined;
    }
}

async function saveSurveyInfo() {
	//TODO show possible error during update
	await dataStore.updateSurvey(appState.view1Survey.uuid, appState.view1Survey.surveyDate, appState.view1Survey.description);
	data.isSurveyDirty = false;
}

async function saveProjectInfo() {
	//TODO show possible error during update
	await dataStore.updateProject(appState.project.uuid, appState.project.name, appState.project.coordinateSystem?.id, appState.project.latLong, appState.project.sharing)
	data.isProjectDirty = false;
}

async function deleteSurvey(survey: Survey) {
	const shouldDelete = confirm(`Are you sure you want to delete survey ${Utils.formatSurveyName(survey)}?`);
	if (!shouldDelete) {
		return;
	}
	const result = await dataStore.deleteSurvey(survey.uuid);
	if (!result) {
		const message = "Error deleting survey, please try again later.";
		notificationStore.addNotification(message);
		console.warn(message);
	}else{
		router.go(0);
	}
}

async function deleteProject(e) {
	e.preventDefault();
	e.stopPropagation();

	if (!appState.project || !appState.project.uuid) {
		return;
	}

	const shouldDelete = confirm("Are you sure you want to delete the project?");
	if (!shouldDelete) {
		return;
	}
	const result = await dataStore.deleteProject(appState.project.uuid);
	if (!result) {
		const message = "Error deleting project, please try again later";
		notificationStore.addNotification(message);
		console.warn(message);
	}else{
		router.replace({ name: "projects" })
	}
}

function setInitialProjectLocation(){
	appState.project.latLong = [0,0];
}

async function downloadSurvey() {
    if (!appState.view1Survey || !appState.view1Survey.uuid) {
        return;
    }
    
    try {
        const downloadUrl = `${Constants.backendUrl}/api/v1/download-survey`;        
        const token = JSON.parse(localStorage.getItem("user")).accessToken;
        const fileStream = StreamSaver.createWriteStream(Utils.formatSurveyName(appState.view1Survey) + ".zip");
        
        const response = await fetch(downloadUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? { "Authorization": `Bearer ${token}` } : {})
            },
            body: JSON.stringify({ surveyUUID: appState.view1Survey.uuid })
        });
        
        if (!response.ok) {
            throw new Error(`Download failed: ${response.statusText}`);
        }
        
        const readableStream = response.body;
        
        if (window.WritableStream && readableStream.pipeTo) {
            return readableStream.pipeTo(fileStream)
                .then(() => console.log("Download completed"));
        }
        
    } catch (error) {
        console.error("Error downloading survey:", error);
        notificationStore.addNotification("Error downloading survey. Please try again later.");
    }
}

onMounted(async () => {
	//Refresh surveys every 5s
	watch(() => appState.view1Survey?.inputFiles, (newFiles) => {
        const hasProjectsInProcessing = newFiles?.some(file => file.status === "processing" || file.status === "waitingforprocessing");
        if (hasProjectsInProcessing) {
            startInterval();
        } else {
            stopInterval();
        }
    }, { deep: true, immediate: true });
})

onBeforeUnmount(() => {
	stopInterval();
});



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(DefaultLayout, { class: "edit-project-page page d-flex flex-column" }, {
    default: _withCtx(() => [
      _createVNode(AppHeader, {
        "show-project": true,
        "show-survey": false
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ProjectPickerSidebar),
        _createElementVNode("div", _hoisted_2, [
          (_unref(appState).project)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, [
                _createElementVNode("nav", _hoisted_4, [
                  _createElementVNode("ol", _hoisted_5, [
                    _createElementVNode("li", _hoisted_6, [
                      _createVNode(_component_router_link, {
                        to: { name: 'edit', params: { projectId: _unref(appState).project.uuid } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(appState).project?.name), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    (_unref(appState).view1Survey)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_7, _toDisplayString(_unref(Utils).formatSurveyName(_unref(appState).view1Survey)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (_unref(appState).project && !_unref(appState).view1Survey)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "d-flex btn-link danger me-3",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteProject($event)))
                      }, " Delete project "))
                    : _createCommentVNode("", true),
                  (_unref(appState).view1Survey)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "d-flex btn-link danger me-3",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (deleteSurvey(_unref(appState).view1Survey)))
                      }, " Delete survey "))
                    : _createCommentVNode("", true),
                  (_unref(appState).view1Survey)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        class: "d-flex btn-link me-3",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (downloadSurvey()))
                      }, " Download survey "))
                    : _createCommentVNode("", true),
                  (_unref(appState).view1Survey)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        class: "d-flex btn-link me-3",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (viewSurvey()))
                      }, " View survey "))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(appState).view1Survey)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _withDirectives(_createElementVNode("input", {
                        name: "description",
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(appState).view1Survey.description) = $event)),
                        onInput: setSurveyDirty
                      }, null, 544), [
                        [_vModelText, _unref(appState).view1Survey.description]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_unref(Datepicker), {
                        modelValue: _unref(appState).view1Survey.surveyDate,
                        "onUpdate:modelValue": [
                          _cache[5] || (_cache[5] = ($event: any) => ((_unref(appState).view1Survey.surveyDate) = $event)),
                          setSurveyDirty
                        ],
                        "auto-apply": true,
                        dark: true
                      }, null, 8, ["modelValue"])
                    ]),
                    (data.isSurveyDirty)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn",
                          onClick: saveSurveyInfo
                        }, "Save"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(SurveyFiles)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_unref(appState).project)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _withDirectives(_createElementVNode("input", {
                            name: "description",
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(appState).project.name) = $event)),
                            onInput: setProjectDirty
                          }, null, 544), [
                            [_vModelText, _unref(appState).project.name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createVNode(CoordinateSystemPicker, {
                            disabled: _unref(appState).project.surveys.length > 0,
                            modelValue: _unref(appState).project.coordinateSystem,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(appState).project.coordinateSystem) = $event)),
                            onInput: setProjectDirty
                          }, null, 8, ["disabled", "modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          (!_unref(appState).project.latLong)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createTextVNode(" Project location not set "),
                                _createElementVNode("button", {
                                  class: "btn-link",
                                  onClick: setInitialProjectLocation
                                }, "Click to set project location manually")
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(appState).project.latLong)
                            ? (_openBlock(), _createBlock(MapLocationPicker, {
                                key: 1,
                                ref_key: "locationPicker",
                                ref: locationPicker,
                                modelValue: _unref(appState).project.latLong,
                                "onUpdate:modelValue": [
                                  _cache[8] || (_cache[8] = ($event: any) => ((_unref(appState).project.latLong) = $event)),
                                  setProjectDirty
                                ],
                                class: "location my-3"
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (data.isProjectDirty)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn",
                            onClick: saveProjectInfo
                          }, "Save"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})